import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ReactNotifications } from 'react-notifications-component';
import React, { useState } from "react";

import { ClienteContext, LastPositionContext } from "./components/services/ClienteContext";
import UserLogin from "./components/Views/Login/UserLogin";
import FileExplorer from './components/Views/FileExplorer/FileExplorer';
import Share from "./components/Views/Home/PublicView/PublicView";

import 'react-notifications-component/dist/theme.css';
import 'animate.css';
import Header from "./components/Views/Header/Header"
import RecPass from "./components/Views/RecPass/Index";


const App = () => {

  const [dados, setDados] = useState({})
  const [posiData, setLastPosiData] = useState({})

  return (
    <ClienteContext.Provider value={{ dados, setDados }}>
      <LastPositionContext.Provider value={{ posiData, setLastPosiData }}>
        <Router basename="/ftpserver">
          <ReactNotifications id='notification' />
          <Routes >
            <Route path="/" element={<UserLogin />} />
            <Route path="/login" element={<UserLogin />} />
            <Route path="/escpass" element={<RecPass />} />
            <Route path="/share/:id" element={<><Header dados={dados} /><Share /></>} />
            <Route path="/home" element={<><Header dados={dados} /><FileExplorer /></>} />
          </Routes>
        </Router>
      </LastPositionContext.Provider>
    </ClienteContext.Provider >
  );
}

export default App;
